<div [hidden]="!menuEnabled">
  <div class="row mt-3">
    <div class="col-12 text-right">
      <span class="text-danger mr-5" *ngIf="notFoundResult" translate>NotfoundFaq</span>
    </div>
    <div class="col-md-4 col-sm-12">
      <img src="../../assets/images/faq_logo.png" style="width: 20vw">
    </div>
    <div class="col-md-4 col-sm-6 text-right  align-self-center">
      <div class="input-group">
        <label translate>Search by:</label>
        <select class="form-control ml-3" [(ngModel)]="searchType" (change)="filterQA()">
          <option value="a" translate>All</option>
          <option value="k" translate>keyword</option>
          <option value="c" translate>Text</option>
        </select>
      </div>
    </div>
    <div class="col-md-4 col-sm-6 align-self-center">
      <!-- <div class="input-group"> -->
      <input type="search" class="form-control" id="filter" placeholder="Search" [(ngModel)]="filterWord">

      <!-- <div class="input-group-append">
        <button class="btn btn-drfault">
          <span class="fa fa-search"></span>
        </button>
      </div> -->
      <!-- </div> -->
    </div>
  </div>

  <div #faq *ngFor="let c of categoryList" class="mb-3">
    <div class="row group">
      <button class="collapsible collapsible-group" (click)="onParentClick($event.target)">
        <img src="../../assets/images/faq1.png" width="30">
        {{c.dpa_name}}
        <i class="fa" aria-hidden="true"></i>
      </button>
      <div class="content w-100 pl-5 pr-5">
        <div class="row mt-1 border border-info rounded question" *ngFor="let f of c.qList">
          <button class="collapsible btn collapsible-question" (click)="onParentClick($event.target)">
            <i class="q-label" translate>Question</i><i>:</i>
            <br>
            <div [innerHtml]="f.dpa_name | highlightSearch: Search" (click)="onBtnLabelClick($event.target)"></div>
          </button>
          <div class="content w-100" title="{{f.dpa_keyword}}">
            <div class="row mt-1 pl-4">
              <div class="col-12">
                <b translate>Answer</b><b>:</b>
              </div>
              <div class="col-12 answer" [innerHTML]="f.dpa_content | highlightSearch: Search">
              </div>
              <div class="col-12 border rounded" *ngIf="f.dpa_attch != ''">
                <div class="card-body km-content" [innerHTML]="f.dpa_attch"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="scroll-top-wrapper" (click)="collapsAll()">
    <span class="scroll-top-inner">
      <i class="fa fa-2x fa-arrow-circle-up"></i>
    </span>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/question-and-answer/question-and-answer.component.html